import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ExposureByTask } from 'src/app/models/exposureBySeg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-group-task-samples',
  templateUrl: './group-task-samples.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./group-task-samples.component.scss']
})
export class GroupTaskSamplesComponent implements OnInit {
  @Input() loadingExposureByTaskGroup: boolean = true;
  @Input() exposureByTaskGroupName: ExposureByTask[];

  @Output() toggleTaskPopupEmit = new EventEmitter<any>();

  errorMessage: string = "";

  constructor(
  ) {
    this.errorMessage = ErrorConstants.errorMessage;
  }

  ngOnInit(): void {
  }

  toggleTaskPopupFn(task: ExposureByTask) {
    this.toggleTaskPopupEmit.emit(task);
  }

  public trackByIndex = trackByIndex;
}
